import { useState, useEffect } from 'react';
import { StaticNoti, UserDTO } from '@/types/other';
import useBackendUser from './useBackendUser';

function useStaticNotifications() {
  const { data: user } = useBackendUser();
  const [staticNoti, setStaticNoti] = useState<StaticNoti>({
    sellerProfileNoti: undefined,
    buyerProfileNoti: undefined,
    totalNoti: undefined,
  });

  useEffect(() => {
    function getUserStaticNotifications(user: UserDTO | null) {
      let sellerProfileNoti = undefined;
      let buyerProfileNoti = undefined;
      let totalNoti = undefined;

      if (!user) return { sellerProfileNoti, buyerProfileNoti, totalNoti };
      // seller profile notifications
      if (!user.canAsk) {
        if (
          ((user.specialProffesional && !user.shippingPolicy) ||
            (!user.isProffesional && !user.shippingPolicy)) &&
          !user.accountNumber
        ) {
          sellerProfileNoti = 2;
        } else if (!user.shippingPolicy || !user.accountNumber) {
          sellerProfileNoti = 1;
        }
      }

      // buyer profile notifications
      if (!user.canBid) {
        buyerProfileNoti = 1;
      }

      // total notifications
      if (
        typeof sellerProfileNoti === 'number' &&
        typeof buyerProfileNoti === 'number'
      ) {
        totalNoti = sellerProfileNoti + buyerProfileNoti;
      }

      return { sellerProfileNoti, buyerProfileNoti, totalNoti };
    }

    setStaticNoti(getUserStaticNotifications(user));
  }, [user]);

  return staticNoti;
}

export default useStaticNotifications;
